<template>
  <div
    :style="{
      '--small': small,
      '--large': large,
    }"
    class="AdaptiveSpace"
  />
</template>

<script>
export default {
  name: 'AdaptiveSpace',
  props: {
    staticHeight: {
      type: String,
    },
    adaptiveHeight: { type: Array },
  },
  data() {
    return { small: null, large: null };
  },
  mounted() {
    if (this.staticHeight) {
      this.small = this.staticHeight;
      this.large = this.staticHeight;
    } else if (this.adaptiveHeight && this.adaptiveHeight.length === 2) {
      const [small, large] = this.adaptiveHeight;
      this.small = small;
      this.large = large;
    } else {
      throw Error(`adaptiveHeight must include 2 arguments`);
    }
  },
};
</script>

<style scoped>
.AdaptiveSpace {
  height: var(--small);
}

@media (min-width: 1024px) {
  .AdaptiveSpace {
    height: var(--large);
  }
}
</style>
